<template>
	<div class="export-promotions">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h3>Export Promotions</h3>

		<div class="radioCheck">
			<b-radio v-model="prefix" name="name" native-value="PPC">PPC</b-radio>
			<b-radio v-model="prefix" name="name" native-value="PPF">PPF</b-radio>
			<b-radio v-model="prefix" name="name" native-value="PPB">PPB</b-radio>
			<b-radio v-model="prefix" name="name" native-value="PPA">PPA</b-radio>
		</div>

		<b-field label="Select Shop (optional)">
			<b-autocomplete
				v-model="shopsSuggestions"
				:data="filteredShops"
				:open-on-focus="true"
				placeholder="Shop"
				field="name"
				@select="option => (selectedShop = option)"
				class="shopAutoComplete"
			>
				<template slot="empty">No results found</template>
			</b-autocomplete>
		</b-field>

		<div class="datepickerWrapper">
			<b-field label="Starting Date From (Required)">
				<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startDateFrom" icon="calendar-today"></b-datepicker>
			</b-field>

			<b-field label="Starting Date To (Required)">
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Click to select..."
					v-model="startDateTo"
					icon="calendar-today"
					:min-date="minDate"
				></b-datepicker>
			</b-field>
		</div>

		<div class="button-container">
			<div class="big-button" @click="submit()">Export Promotions</div>
		</div>

		<div v-if="progress > 0">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
	</div>
</template>

<script>
export default {
	name: 'productsCheck',
	data: () => ({
		limit: 100,
		isLoading: false,
		exportPromotions: [],
		prefix: 'PPC',
		startDateFrom: null,
		startDateTo: null,
		minDate: null,
		brands: [],
		promotions: [],
		progress: 0,
		shops: [], // For list of shops from API
		shopsSuggestions: '', // For dropdown selection
		selectedShop: null // Selected shop
	}),

	mounted: async function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		await this.getBrands()

		await this.getShops()
	},

	watch: {
		startDateFrom: function(data) {
			this.minDate = data

			this.startDateTo = data
		}
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		submit: async function() {
			this.exportPromotions = []
			this.promotions = []
			this.progress = 0

			if (this.startDateFrom == null || this.startDateTo == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Please select both dates'
				})

				return
			}

			this.isLoading = true

			// For start date
			const dateFrom = this.$moment(this.startDateFrom)
				.set({ hour: 0 })
				.format('x')

			// For end date
			const dateTo = this.$moment(this.startDateTo)
				.set({ hour: 24 })
				.format('x')

			var data = {
				limit: this.limit,
				populate: ['shops'],
				sort: {
					createdAt: 'asc'
				},
				date: {
					from: {
						$gte: dateFrom,
						$lte: dateTo
					}
				}
			}

			if (this.selectedShop) {
				data.shop = this.selectedShop._id
			}

			const apiGetPromotions = await this.$api.getPromotionList({ data })

			if (!apiGetPromotions) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'No result found'
				})

				return
			}

			apiGetPromotions.data.list.map(promo => {
				this.promotions.push(promo)
			})

			if (apiGetPromotions.data.total > this.limit) {
				var totalLoop = Math.ceil(apiGetPromotions.data.total / this.limit)

				var i
				var skip

				// Loop all the pagers
				for (i = 1; i < totalLoop; i++) {
					skip = i * this.limit

					data.skip = skip

					const results = await this.$api.getPromotionList({ data })

					results.data.list.map(promo => {
						this.promotions.push(promo)
					})
				}
			}

			// Loop all the promotion groups
			for (let promotion of this.promotions) {
				if (promotion.code.startsWith(this.prefix)) {
					data = {
						id: promotion._id,
						populate_promotion_group: ['shops']
					}

					// Get promotion group details
					const apiGetPromoDetail = await this.$api.getPromotionDetail({ data })

					this.exportPromotions.push(apiGetPromoDetail.data)
				}
			}

			this.generateCSV()
		},

		generateCSV: async function() {
			let csv = ''
			var count = 0

			// For Order FOC
			if (this.prefix == 'PPA') {
				csv = 'PROMO CODE,PROMO NAME,SHOPS,AMOUNT,GET,START DATE,END DATE,UPDATED DATE,CREATED DATE\r\n'

				for (let promotionGroup of this.exportPromotions) {
					count++
					this.progress = (count / this.exportPromotions.length) * 100

					for (let promotion of promotionGroup.promotions) {
						csv += promotionGroup.code + ',' + promotionGroup.name + ','
						csv += '"'
						let promoShop = []

						promotionGroup.shops.map(shop => {
							promoShop.push(shop.shop_id)
						})

						let status = 'enabled'

						if (promotionGroup.shops && promotionGroup.shops.length < 1) {
							status = 'disabled'
						}

						let promoShops = promoShop.join(',')
						// add shops to csv
						csv += promoShops + '",'

						// For Brand FOC
						if (promotion.type == 'discount_order_foc__from_product_list') {
							csv += promotion.condition.target + ','

							// Loop get free products
							let focProducts = []

							for (let focProduct of promotion.condition.products) {
								const data = {
									id: focProduct
								}
								const getProduct = await this.$api.getProductDetail({ data })

								focProducts.push(getProduct.data.bd_code)
							}

							let toAddFocProducts = focProducts.join(',')
							// add shops to csv
							csv += '"' + toAddFocProducts + '",'
						}

						csv += this.$moment(promotionGroup.date.from).format('DD/MM/YYYY') + ',' + this.$moment(promotionGroup.date.to).format('DD/MM/YYYY') + ','
						csv +=
							this.$moment(promotionGroup.updatedAt).format('DD/MM/YYYY HH:mm') +
							',' +
							this.$moment(promotionGroup.createdAt).format('DD/MM/YYYY HH:mm') +
							',' +
							status
						csv += '\r\n'
					}
					csv += '\r\n'
				}
			}

			// For Brand FOC
			if (this.prefix == 'PPB') {
				csv = 'PROMO CODE,PROMO NAME,SHOPS,BRAND NAME,BRAND,AMOUNT,GET,START DATE,END DATE,UPDATED DATE,CREATED DATE\r\n'

				for (let promotionGroup of this.exportPromotions) {
					count++
					this.progress = (count / this.exportPromotions.length) * 100

					for (let promotion of promotionGroup.promotions) {
						csv += promotionGroup.code + ',' + promotionGroup.name + ','
						csv += '"'
						let promoShop = []

						promotionGroup.shops.map(shop => {
							promoShop.push(shop.shop_id)
						})

						let status = 'enabled'

						if (promotionGroup.shops && promotionGroup.shops.length < 1) {
							status = 'disabled'
						}

						let promoShops = promoShop.join(',')
						// add shops to csv
						csv += promoShops + '",'

						// For Brand FOC
						if (promotion.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand') {
							const matchBrand = this.brands.filter(brand => {
								return brand._id == promotion.condition.brand
							})

							csv += matchBrand[0].name + ',' + matchBrand[0].code + ',' + promotion.condition.target + ','

							// Loop get free products
							let focProducts = []

							for (let focProduct of promotion.condition.products) {
								const data = {
									id: focProduct
								}
								const getProduct = await this.$api.getProductDetail({ data })

								focProducts.push(getProduct.data.bd_code)
							}

							let toAddFocProducts = focProducts.join(',')
							// add shops to csv
							csv += '"' + toAddFocProducts + '",'
						}

						csv += this.$moment(promotionGroup.date.from).format('DD/MM/YYYY') + ',' + this.$moment(promotionGroup.date.to).format('DD/MM/YYYY') + ','
						csv +=
							this.$moment(promotionGroup.updatedAt).format('DD/MM/YYYY HH:mm') +
							',' +
							this.$moment(promotionGroup.createdAt).format('DD/MM/YYYY HH:mm') +
							',' +
							status

						csv += '\r\n'
					}
					csv += '\r\n'
				}
			}

			// Buy 1 Get 1
			if (this.prefix == 'PPF') {
				csv = 'PROMO CODE,PROMO NAME,SHOPS,BRAND/ITEM,CODE,GET,PERCENTAGE,START DATE,END DATE,UPDATED DATE,CREATED DATE\r\n'

				for (let promotionGroup of this.exportPromotions) {
					count++
					this.progress = (count / this.exportPromotions.length) * 100

					// promotionGroup.promotions.map(async promotion => {})
					for (let promotion of promotionGroup.promotions) {
						// Promo code and promo name
						csv += promotionGroup.code + ',' + promotionGroup.name + ','
						csv += '"'
						let promoShop = []

						promotionGroup.shops.map(shop => {
							promoShop.push(shop.shop_id)
						})

						let status = 'enabled'

						if (promotionGroup.shops && promotionGroup.shops.length < 1) {
							status = 'disabled'
						}

						let promoShops = promoShop.join(',')
						// add shops to csv
						csv += promoShops + '",'

						// For Buy 1 Get 1
						if (promotion.type == 'discount_product_buy_and_get_foc_from_list') {
							const data = {
								id: promotion.condition.target_products[0]
							}
							const targetProduct = await this.$api.getProductDetail({ data })

							// Brand and BD Code
							csv += '"' + targetProduct.data.name + '",' + targetProduct.data.bd_code + ','

							// Loop get free products
							let focProducts = []

							for (let focProduct of promotion.condition.products) {
								const data = {
									id: focProduct
								}
								const getProduct = await this.$api.getProductDetail({ data })

								focProducts.push(getProduct.data.bd_code)
							}

							let toAddFocProducts = focProducts.join(',')
							// add shops to csv
							csv += '"' + toAddFocProducts + '",'
							csv += ',' // Extra for percentage

							// Start date and end date
							csv +=
								this.$moment(promotionGroup.date.from).format('DD/MM/YYYY') + ',' + this.$moment(promotionGroup.date.to).format('DD/MM/YYYY') + ','
							csv +=
								this.$moment(promotionGroup.updatedAt).format('DD/MM/YYYY HH:mm') +
								',' +
								this.$moment(promotionGroup.createdAt).format('DD/MM/YYYY HH:mm') +
								',' +
								status

							csv += '\r\n'
							// }
						}

						// For Buy 1 Get 1 Percentage
						if (promotion.type == 'discount_product_buy_one_get_one_and_percentage') {
							const data = {
								id: promotion.condition.target_products[0]
							}
							const targetProduct = await this.$api.getProductDetail({ data })

							// Brand and BD Code
							csv += '"' + targetProduct.data.name + '",' + targetProduct.data.bd_code + ','

							// Loop get free products
							let focProducts = []

							for (let focProduct of promotion.condition.products) {
								const data = {
									id: focProduct
								}
								const getProduct = await this.$api.getProductDetail({ data })

								focProducts.push(getProduct.data.bd_code)
							}

							let toAddFocProducts = focProducts.join(',')
							// add shops to csv
							csv += '"' + toAddFocProducts + '",'
							csv += promotion.condition.percentage + ','

							// Start date and end date
							csv +=
								this.$moment(promotionGroup.date.from).format('DD/MM/YYYY') + ',' + this.$moment(promotionGroup.date.to).format('DD/MM/YYYY') + ','
							csv +=
								this.$moment(promotionGroup.updatedAt).format('DD/MM/YYYY HH:mm') +
								',' +
								this.$moment(promotionGroup.createdAt).format('DD/MM/YYYY HH:mm') +
								',' +
								status

							csv += '\r\n'
							// }
						}

						// For Buy 2 Get 1
						if (promotion.type == 'discount_order_buy_two_get_one') {
							if (promotion.condition.target_qty == 1) {
								let i = 1 // For second product not to add promo name and code again at the front
								for (const target_product of promotion.condition.target_products) {
									if (i == 2) {
										csv += ',,,'
									}
									const data = {
										id: target_product
									}
									const targetProduct = await this.$api.getProductDetail({ data })

									// Brand and BD Code
									csv += '"' + targetProduct.data.name + '",' + targetProduct.data.bd_code + ','

									// Loop get free products
									let focProducts = []

									for (let focProduct of promotion.condition.products) {
										const data = {
											id: focProduct
										}
										const getProduct = await this.$api.getProductDetail({ data })

										focProducts.push(getProduct.data.bd_code)
									}

									let toAddFocProducts = focProducts.join(',')
									// add shops to csv
									csv += '"' + toAddFocProducts + '",'
									csv += ',' // for percentage

									// Start date and end date
									csv +=
										this.$moment(promotionGroup.date.from).format('DD/MM/YYYY') +
										',' +
										this.$moment(promotionGroup.date.to).format('DD/MM/YYYY') +
										','
									csv +=
										this.$moment(promotionGroup.updatedAt).format('DD/MM/YYYY HH:mm') +
										',' +
										this.$moment(promotionGroup.createdAt).format('DD/MM/YYYY HH:mm') +
										',' +
										status

									csv += '\r\n'
									// }
									i++ // For second product not to add promo name and code again at the front
								}
							} else if (promotion.condition.target_qty == 2) {
								const data = {
									id: promotion.condition.target_products[0]
								}
								const targetProduct = await this.$api.getProductDetail({ data })

								// Brand and BD Code
								csv += '"' + targetProduct.data.name + '",' + targetProduct.data.bd_code + ','

								// Loop get free products
								let focProducts = []

								for (let focProduct of promotion.condition.products) {
									const data = {
										id: focProduct
									}
									const getProduct = await this.$api.getProductDetail({ data })

									focProducts.push(getProduct.data.bd_code)
								}

								let toAddFocProducts = focProducts.join(',')
								// add shops to csv
								csv += '"' + toAddFocProducts + '",'
								csv += ',' // for percentage

								// Start date and end date
								csv +=
									this.$moment(promotionGroup.date.from).format('DD/MM/YYYY') + ',' + this.$moment(promotionGroup.date.to).format('DD/MM/YYYY') + ','
								csv +=
									this.$moment(promotionGroup.updatedAt).format('DD/MM/YYYY HH:mm') +
									',' +
									this.$moment(promotionGroup.createdAt).format('DD/MM/YYYY HH:mm') +
									',' +
									status

								csv += '\r\n'
								// }
							}
						}
					}

					csv += '\r\n'
				}
			}

			// For Brand Discount, Price Point percent and fixed amount
			if (this.prefix == 'PPC') {
				csv = 'PROMO CODE,PROMO NAME,SHOPS,BRAND/ITEM,CODE,PERCENTAGE,DISCOUNT AMOUNT,START DATE,END DAT,UPDATED DATE,CREATED DATE,STATUS\r\n'

				for (let promotionGroup of this.exportPromotions) {
					count++
					this.progress = (count / this.exportPromotions.length) * 100

					for (let promotion of promotionGroup.promotions) {
						csv += promotionGroup.code + ',' + promotionGroup.name + ','
						csv += '"'
						let promoShop = []

						promotionGroup.shops.map(shop => {
							promoShop.push(shop.shop_id)
						})

						let status = 'enabled'

						if (promotionGroup.shops && promotionGroup.shops.length < 1) {
							status = 'disabled'
						}

						let promoShops = promoShop.join(',')
						// add shops to csv
						csv += promoShops + '",'

						// For Brand Discount
						if (promotion.type == 'discount_product_percentage_by_brands') {
							const matchBrand = this.brands.filter(brand => {
								return brand._id == promotion.condition.brands[0]
							})

							// now get all the products from the brand
							const data = {
								limit: 100,
								brand: matchBrand[0]._id
							}

							const apiExportProducts = await this.$api.getProducts({ data })

							if (apiExportProducts && apiExportProducts.data && apiExportProducts.data.list) {
								console.log(apiExportProducts.data.list)

								for (let i = 0; i < apiExportProducts.data.count; i++) {
									if (promotionGroup.code == 'PPC021-27-02-23') {
										console.log(i)
									}
									const productInfo = apiExportProducts.data.list[i]

									if (i !== 0) {
										csv += promotionGroup.code + ',' + promotionGroup.name + ','
										csv += '"'
										csv += promoShops + '","'
									}

									csv += productInfo.name + '",' + productInfo.bd_code + ',' + promotion.condition.percentage + ',,'

									if (i !== apiExportProducts.data.count - 1) {
										csv +=
											this.$moment(promotionGroup.date.from).format('DD/MM/YYYY') +
											',' +
											this.$moment(promotionGroup.date.to).format('DD/MM/YYYY') +
											','
										csv +=
											this.$moment(promotionGroup.updatedAt).format('DD/MM/YYYY HH:mm') +
											',' +
											this.$moment(promotionGroup.createdAt).format('DD/MM/YYYY HH:mm') +
											',' +
											status
										csv += '\r\n'
									}
								}
							} else {
								csv += matchBrand[0].name + ',' + matchBrand[0].code + ',' + promotion.condition.percentage + ',,'
							}
						}

						// For Price Point (percent)
						if (promotion.type == 'discount_product_percentage') {
							const data = {
								id: promotion.condition.products[0]
							}
							const getProduct = await this.$api.getProductDetail({ data })

							csv += '"' + getProduct.data.name + '",' + getProduct.data.bd_code + ',' + promotion.condition.percentage + ',,'
						}

						// For Price Point (fixed amount)
						if (promotion.type == 'discount_product_price') {
							const data = {
								id: promotion.condition.products[0]
							}
							const getProduct = await this.$api.getProductDetail({ data })

							csv += getProduct.data.name + ',' + getProduct.data.bd_code + ',,' + promotion.condition.price + ','
						}

						csv += this.$moment(promotionGroup.date.from).format('DD/MM/YYYY') + ',' + this.$moment(promotionGroup.date.to).format('DD/MM/YYYY') + ','
						csv +=
							this.$moment(promotionGroup.updatedAt).format('DD/MM/YYYY HH:mm') +
							',' +
							this.$moment(promotionGroup.createdAt).format('DD/MM/YYYY HH:mm') +
							',' +
							status
						csv += '\r\n'
					}
					csv += '\r\n'
				}
			}

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'promotions.csv')
			document.body.appendChild(link) // Required for FF

			link.click()
			link.remove()

			this.isLoading = false
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/ExportPromotions.css';
</style>
